import React from 'react';
import {GetRequestResponsePayload} from '../../../../../../shared/models/api';
import {NamedStyles, useStyles} from '../../../../../../shared/hooks/styles';
import {Links} from './links';
import {DeviceSize} from '../../../../../../shared/theme/helpers';
import {Text} from '../../../../../../shared/components/text';
import {CustomScrollView} from '../../../../../../shared/components/scrollView';
import {Html} from '../../../../../../shared/components/html';
import {MixedTextToHtmlOnly} from '../../../../../../shared/utils/text';

export const ResponseBlock = ({
  request,
  styles,
}: {
  request: GetRequestResponsePayload | null;
  styles: NamedStyles<any>;
}) => {
  const innerStyles = useStyles(({theme, mediaOnly}) => ({
    html: {
      ...mediaOnly(DeviceSize.desktop, {marginTop: 20}, {marginTop: 14}),
      width: '100%',
    },
    htmlBaseFont: mediaOnly(DeviceSize.desktop, theme.fonts.h5Light),
    title: {
      ...theme.fonts.h6,
      ...mediaOnly(
        DeviceSize.desktop,
        {
          marginTop: 40,
        },
        {
          marginTop: 25,
        },
      ),
    },
    bodyText: {
      ...theme.fonts.h6Light,
      maxWidth: '100%',
    },
  }));

  return request?.response ? (
    <>
      <Text style={innerStyles.title} testID='topic-response-title'>
        Ответ службы поддержки
      </Text>
      <CustomScrollView>
        <Html content={MixedTextToHtmlOnly(request?.response)} testID='topic-request-text' />
      </CustomScrollView>
      <Links type='response' request={request} styles={styles} />
    </>
  ) : (
    <Text style={styles.noResponseText} testID='topic-no-response-text'>
      Ваше обращение получено. Ответ будет направлен в ближайшее время.
    </Text>
  );
};
